<button (click)="clicked()">
  <studio-icon *ngIf="icon" [name]="icon" [title]="icon" size="24"></studio-icon>
  <ng-content></ng-content>
</button>
